import _ from 'lodash';
import VisibilitySensor from './visibility-sensor';
import { useState } from 'react';
import { FadeInAnimation } from '../src/components/shared';

export function parseTitle(text, id, isMainHeaderOne, noFade) {
    return <ParsedTitle text={text} id={id} isMainHeaderOne={isMainHeaderOne} noFade={noFade} />;
}

function ParsedTitle({ text, id, isMainHeaderOne, noFade }) {
    const [isTextVisible, setTextVisible] = useState(false);   

    const regex = {
        paragraph: /(?:\r\n){2,}/g,
        emphasize: /(_.*?_)/g,
    };

    let paragraph = _.split(text, regex.paragraph) || [];

    paragraph = paragraph.map((item, i) => {
        if (isMainHeaderOne) {
            return (
                <h1 key={i} id={id} style={{ margin: '0px' }}>
                    {item.split(regex.emphasize).map((str, j) => {
                        if (str.search(regex.emphasize) !== -1) {
                            const clean = str.replace(/^_/, '').replace(/_$/, '');
                            return (
                                <span className={`${isTextVisible ? 'title-parser-heading-span-visible' : 'title-parser-heading-span-hidden'}`} key={`span-${i}-${j}`}>
                                    {clean}
                                </span>
                            );
                        }
                        return <span key={`text-${i}-${j}`}>{str}</span>;
                    })}
                </h1>
            );
        }
        return (
            <p key={i} id={id} style={{ margin: '0px' }} className='dummy-header-one'>
                {item.split(regex.emphasize).map((str, j) => {
                    if (str.search(regex.emphasize) !== -1) {
                        const clean = str.replace(/^_/, '').replace(/_$/, '');
                        return (
                            <span className={`${isTextVisible ? 'title-parser-heading-span-visible' : 'title-parser-heading-span-hidden'}`} key={`span-${i}-${j}`}>
                                {clean}
                            </span>
                        );
                    }
                    return <span key={`text-${i}-${j}`}>{str}</span>;
                })}
            </p>
        );
    });

    const renderHeader = () => {
        if (noFade) {
            return <>{paragraph}</>;
        }
        return <FadeInAnimation>{paragraph}</FadeInAnimation>;
    };

    return (
        <VisibilitySensor
            onChange={(isVisible) => {
                setTextVisible(isVisible);
            }}            
        >
            <div>{renderHeader()}</div>
        </VisibilitySensor>
    );
}

